module.exports = "<div class=\"page\">\r\n    <div ng-repeat=\"x in list.ListWidgetService.widgets\" >\r\n        <div ng-class=\"(x.showItem()) ? 'col s12 row listitem' : '' \" ng-show=\"x.showItem()\">\r\n            <list-item index='$index' info='x'></list-item>\r\n        </div>\r\n    </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/list.html
// module id = 320
// module chunks = 0